var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7506 37.1175L35.0103 28.8837H32.0033L33.6732 36.9128H4.27358L5.94342 28.8837H2.93651L0.194204 37.1175C-0.501396 39.2131 0.731439 40.9273 2.93651 40.9273H35.0103C37.2153 40.9273 38.4482 39.2131 37.7506 37.1175ZM28.9964 10.8182C28.9964 8.15641 27.9404 5.60363 26.0608 3.72144C24.1811 1.83926 21.6317 0.78186 18.9734 0.78186C16.3151 0.78186 13.7657 1.83926 11.886 3.72144C10.0063 5.60363 8.95034 8.15641 8.95034 10.8182C8.95034 20.403 18.9734 30.891 18.9734 30.891C18.9734 30.891 28.9964 20.403 28.9964 10.8182ZM13.5609 10.9387C13.5609 7.94582 15.9825 5.52103 18.9734 5.52103C20.4086 5.52103 21.785 6.09192 22.7999 7.10811C23.8147 8.1243 24.3848 9.50255 24.3848 10.9397C24.3848 12.3768 23.8147 13.755 22.7999 14.7712C21.785 15.7874 20.4086 16.3583 18.9734 16.3583C17.5379 16.3583 16.1612 15.7873 15.1462 14.7709C14.1312 13.7545 13.5609 12.376 13.5609 10.9387Z",
    fill: "#113E41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.90134f2091f7dba8c3b046e7619bb859.svg";
export { ForwardRef as ReactComponent };